import { render, staticRenderFns } from "./facturaEdit.vue?vue&type=template&id=32782c16&"
import script from "./facturaEdit.vue?vue&type=script&lang=js&"
export * from "./facturaEdit.vue?vue&type=script&lang=js&"
import style0 from "./facturaEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports